import { Fragment, type FC } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { Chip, typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

import {
  getMapLabelByOperationType,
  OperationTypesEnum,
} from '../constants/singleFlow.js';
import type { EntityGroupType } from '../types/singleFlow.js';

type Props = {
  items: EntityGroupType;
};

const EntityGroup: FC<Props> = ({ items }) => {
  const { t } = useTranslation('@myn/approval_v2');
  const mapLabelByOperationType = getMapLabelByOperationType(t);

  return (
    <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
      {items.map((item, index) => {
        return (
          <Fragment key={item.value}>
            {index === 0 ? null : (
              <span
                className={cn(
                  typographyVariants({
                    variant: 'bodyShort01',
                    color: 'secondary',
                  }),
                  'uppercase',
                )}
              >
                {mapLabelByOperationType[OperationTypesEnum.enum.or]}
              </span>
            )}
            <Chip variant="outline" size="medium" color="silver">
              {item.label}
            </Chip>
          </Fragment>
        );
      })}
    </div>
  );
};

export default EntityGroup;
